import {environment} from '../../../../src/environments/environment';
import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../shared/auth.service';
import {ApiService} from '../../shared/api.service';
import {AppStateService} from '../../shared/app-state.service';
import {NavigationService} from '../../shared/navigation.service';
import {StorageService} from '../../shared/storage.service';

@Component({
  selector: 'logout-page',
  template: '',
  styles: ['']
})
export class LogoutPageComponent implements OnInit {

  constructor(private Api: ApiService,
              private Auth: AuthService,
              private Navigation: NavigationService,
              private AppState: AppStateService,
              private Storage: StorageService) {
  }

  ngOnInit() {
    this.AppState.loading$.next(true);
    this.Auth.removeAuthentication();
    // this.Api.clearCache();

    if (environment.flags.matLogin && !this.Storage.get('autotest')) {
      window.location.href = `${environment.matHost}/myaquent/logout`;
      return;
    }

    this.Api.refreshUser()
      .subscribe(() => this.Navigation.handleLogin(),
        () => this.Navigation.handleLogin());
  }
}
